// src/pages/SpecialSchool.js
import React, { useState } from 'react'; // Import useState for lightbox
import './SpecialSchool.css';

import schoolBuilding from '../assets/lilatai.jpg';

// --- Lightbox Imports ---
import Lightbox from 'react-18-image-lightbox'; // Import Lightbox component
import 'react-18-image-lightbox/style.css'; // Import Lightbox CSS (Crucial!)


// --- Dynamic Image Import for Special School Gallery ---
const importAll = (r) => {
  // This function maps over all the keys (file paths) returned by require.context
  // and imports each one, returning an array of the imported image modules.
  return r.keys().map(r);
};

// Use require.context to get all image files from the specified directory.
// 1. '../assets/special_school_gallery/' : The directory to search in.
// 2. false : Whether to search subdirectories (we don't need to here).
// 3. /\.jpe?g$|\.png$/ : A regex to match files ending with .jpg, .jpeg, or .png.
const specialSchoolGalleryPhotos = importAll(require.context('../assets/special_school_gallery/', false, /\.jpe?g$|\.png$/));

// You can console.log(specialSchoolGalleryPhotos) here to see the array of image paths
// console.log(specialSchoolGalleryPhotos);

function SpecialSchool() {
  // --- State for Lightbox ---
  const [photoIndex, setPhotoIndex] = useState(0); // Index of the currently viewed photo
  const [isOpen, setIsOpen] = useState(false);     // Whether the lightbox is open

  const openLightbox = (index) => {
    setPhotoIndex(index);
    setIsOpen(true);
  };

  return (
    <div className="special-school-page">

        {/* --- Hero Section --- */}
        <section className="school-hero-section">
          <h1 className="school-hero-heading">Late Lilatai Deshmukh Education, Training & Rehabilitation Centre For Mentally Challenged Girls (Special School)</h1>
          <p className="school-hero-subheading">
            
          </p>
        </section>

      <div className="container">
        {/* --- Introduction & History Section --- */}
        <section className="school-intro-section">
          <h2 className="school-section-title">Our Foundation & Purpose</h2>
          <p>
            Vishwambhara Shikshan Sanstha (VSS) initiated its mission in <b>2006</b>, driven by a profound commitment to the intellectual, educational, and social development of mentally challenged girl students. It was then that the <b>Smt. Lilatai Deshmukh Residential Special School</b> was established. Our core purpose is to empower these girls through specialized education, training, and rehabilitation, fostering self-dependence and self-reliance.
          </p>
          <p>
            The school currently provides special education to <b>65 mentally challenged girls</b>, a capacity sanctioned by the Maharashtra Government since 2006.
          </p>
          <p className="school-highlight-text">
            VSS is deeply committed to the rehabilitation of these girls through comprehensive vocational training, a crucial step towards their independence. We are tirelessly working to achieve this vital goal.
          </p>
        </section>

        {/* Optional Image Section 1 */}
        <div className="school-image-wrapper">
          <img
            src={schoolBuilding}
            alt="Special School Building"
            className="school-image"
          />
        </div>

        {/* --- School Life & Activities Section --- */}
        <section className="school-activities-section">
          <h2 className="school-section-title">Enriching School Life & Activities</h2>
          <p>
            The celebration of various <b>festivals and birthdays</b> is an integral part of our school's vibrant activities. These events play a crucial role in spreading awareness, fostering social interaction, and cultivating a strong sense of community among our students.
          </p>
          <p>
            We also thoughtfully arrange visits by <b>prominent and learned individuals</b> from both within and outside Nagpur. These interactions provide invaluable exposure and inspiration, greatly benefiting our students' holistic development.
          </p>
        </section>

        {/* --- Age Group & Early Intervention Section --- */}
        <section className="school-age-group-section">
          <h2 className="school-section-title">Age Groups & Early Intervention</h2>
          <div className="age-group-details">
            <p className="age-range">Our school caters to an age group ranging from <b>3 to 18 years</b>.</p>
            <div className="early-intervention-box">
              <h3>Early Intervention Center</h3>
              <p>For the <b>3 to 6 year</b> age group, we provide a specialized early intervention center, focusing on foundational development.</p>
            </div>
          </div>
        </section>

        {/* --- Special Classes Section --- */}
        <section className="special-classes-section">
          <h2 className="school-section-title">Our Special Classes</h2>
          <div className="class-list-grid">
            <div className="class-card">
              <h3>Pre-Primary</h3>
              <p>Foundational learning for young minds.</p>
            </div>
            <div className="class-card">
              <h3>Primary</h3>
              <p>Core academic and life skills development.</p>
            </div>
            <div className="class-card">
              <h3>Secondary</h3>
              <p>Advanced learning and social integration.</p>
            </div>
            <div className="class-card">
              <h3>Pre-Vocational</h3>
              <p>Preparing students for vocational training.</p>
            </div>
            <div className="class-card">
              <h3>Special Need</h3>
              <p>Tailored support for unique individual requirements.</p>
            MBA            </div>
          </div>
        </section>

        {/* --- Gallery Section (with Lightbox) --- */}
        <section className="school-gallery-section">
          <h2 className="school-section-title">Our Moments of Joy & Learning</h2>
          <div className="gallery-grid">
            {specialSchoolGalleryPhotos.map((photoUrl, index) => (
              <div
                className="gallery-item"
                key={index}
                onClick={() => openLightbox(index)} // Open lightbox on click
                style={{ cursor: 'pointer' }} // Visual cue for clickable items
              >
                {/* Ensure alt text is meaningful, or add it to the image array if available */}
                <img src={photoUrl} alt={`Special School Moment ${index + 1}`} className="gallery-image" loading="lazy" />
                <div className="gallery-overlay">
                  {/* You could add a caption here if your image data included one */}
                  <span className="gallery-caption">View Photo</span>
                </div>
              </div>
            ))}
          </div>

          {/* --- Lightbox Component --- */}
          {isOpen && (
            <Lightbox
              mainSrc={specialSchoolGalleryPhotos[photoIndex]}
              nextSrc={specialSchoolGalleryPhotos[(photoIndex + 1) % specialSchoolGalleryPhotos.length]}
              prevSrc={specialSchoolGalleryPhotos[(photoIndex + specialSchoolGalleryPhotos.length - 1) % specialSchoolGalleryPhotos.length]}
              onCloseRequest={() => setIsOpen(false)}
              onMovePrevRequest={() =>
                setPhotoIndex((photoIndex + specialSchoolGalleryPhotos.length - 1) % specialSchoolGalleryPhotos.length)
              }
              onMoveNextRequest={() =>
                setPhotoIndex((photoIndex + 1) % specialSchoolGalleryPhotos.length)
              }
              imageTitle={`Photo ${photoIndex + 1} of ${specialSchoolGalleryPhotos.length}`}
              // Add other Lightbox props as needed, e.g., imageCaption, enableZoom
            />
          )}
        </section>

      </div> {/* End .container */}
    </div>
  );
}

export default SpecialSchool;